<div class="row ng-scope">
  <div class="col-12">
    <div class="row form-group">
      <label class="control-label col-3">{{'Chi nhánh' | translate}}</label>
      <div class="col-9">
        <ng-select #slChiNhanh
                   class="twcollong"
                   [tabIndex]="1"
                   [openOnEnter]="false"
                   [items]="dschinhanhs"
                   bindValue="Id"
                   bindLabel="Ten"
                   tabindex="25"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   [(ngModel)]="doituongSelect.DonViId">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>
    <div class="row form-group">
      <label class="control-label col-3">{{'Mã' | translate}}</label>
      <div class="col-9">
        <input type="text" #mafocus [autofocus] tabIndex="2" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Ma">
      </div>
    </div>
    <div class="row form-group">
      <label class="control-label col-3">{{'Tên' | translate}}</label>
      <div class="col-9">
        <input type="text" tabIndex="3" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Ten">
      </div>
    </div>
    <!--<div class="row form-group">
    <label class="control-label col-3">{{'Năm sinh' | translate}}</label>
    <div class="col-9">
      <input class="form-control"
             maxlength="20"
             tabindex="8"
             currencyMask
             [(ngModel)]="doituongSelect.NamSinh"
             name="value"
             [placeholder]="''"
             [options]="ngxCurrencyOptions" autocomplete="off" />
    </div>
  </div>-->


    <div class="row form-group">
      <label class="control-label col-3">{{'Ghi chú' | translate}}</label>
      <div class="col-9">
        <input type="text" tabIndex="4" class="form-control" placeholder="" [(ngModel)]="doituongSelect.GhiChu">
      </div>
    </div>




    <!--<div class="row form-group"  *ngIf="tudanhsach==1">
    <label class="control-label col-3">{{'Nội dung tư vấn' | translate}}</label>
    <div class="col-9">
      <ejs-richtexteditor style="background-color:white" height='250px' #toolsRTE id='alltoolRTE_ch' [toolbarSettings]='tools' [showCharCount]='true' [(value)]='doituongSelect.NoiDungTuVan'
                          [maxLength]='maxLength' [fileManagerSettings]='fileManagerSettings' [quickToolbarSettings]='quickToolbarSettings'
                          (actionBegin)='handleFullScreen($event)' (actionComplete)='actionCompleteHandler($event)'>
      </ejs-richtexteditor>

    </div>
  </div>-->


    <div class="row form-group">
      <label class="control-label col-3 ng-binding">Ngày tạo</label>
      <div class="col-9">
        <kendo-dateinput tabindex="13" style="width:100%;" disabled="disabled" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.Created"></kendo-dateinput>
      </div>
    </div>
    <div class="row form-group">
      <label class="control-label col-3 ng-binding">Người Tạo</label>
      <div class="col-9">
        <input type="text" tabIndex="14" class="form-control" placeholder="" disabled="disabled" [(ngModel)]="doituongSelect.CreatedBy">
      </div>
    </div>


    <div class="row form-group">
      <label class="control-label col-3 ng-binding">Ngày sửa</label>
      <div class="col-9">
        <kendo-dateinput tabindex="13" style="width:100%;" disabled="disabled" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.Modified"></kendo-dateinput>
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-3 ng-binding">Người sửa</label>
      <div class="col-9">
        <input type="text" tabIndex="14" class="form-control" placeholder="" disabled="disabled" [(ngModel)]="doituongSelect.ModifiedBy">
      </div>
    </div> 



  </div>

</div>

<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <!--<div class="checkbox c-checkbox">
      <label>
        <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThaiXuLy" />
        <span class="fa fa-check"></span> {{'Đã xử lý xong' | translate}}
      </label>
    </div>-->
  </div>

  <div class="">
    <button style="float:left !important" class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="">{{'Hủy bỏ' | translate}}</button>
    <button style="float:left !important" type="submit" (click)="saveproduct()" title="" class="mb-1 mr-1 btn btn-primary">{{'Lưu lại' | translate}}</button>
  </div>

</div>


<!--<div id='target' class="control-section">
  <ejs-dialog #dialogObj id='dialog' [visible]='visible' [header]='dialogHeader' [animationSettings]='animationSettings' [showCloseIcon]='showCloseIcon' (open)="dialogOpen()" (close)="dialogClose()"
              [target]='target' [width]='dialogWidth'>
    <ejs-filemanager #filemanagerObj id='filemanager' (beforeSend)="OnbeforeSend($event)"
                     [ajaxSettings]='ajaxSettings' [toolbarSettings]='toolbarSettings'
                     [contextMenuSettings]='contextMenuSettings'
                     [allowMultiSelection]='false' (fileOpen)="onFileOpen($event)">
    </ejs-filemanager>
  </ejs-dialog>
</div>-->
